import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import { SignPage } from './agreements/SignPage';
import { ResetPasswordPage } from './ResetPasswordPage';
import { VerifyPage } from './agreements/VerifyPage';

// /sign/<token> is the public page a customer opens from their "please sign" email — no login.
const signToken = window.location.pathname.match(/^\/sign\/([A-Za-z0-9_-]+)\/?$/)?.[1];
// /reset-password#<token> is opened from the "reset your password" email — no login.
const isReset = /^\/reset-password\/?$/.test(window.location.pathname);
// /verify: anyone can check a signed PDF hasn't been changed — no login.
const isVerify = /^\/verify\/?$/.test(window.location.pathname);

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    {signToken ? <SignPage token={signToken} /> : isReset ? <ResetPasswordPage /> : isVerify ? <VerifyPage /> : <App />}
  </React.StrictMode>
);
